import { render } from "./Projects.vue?vue&type=template&id=117006d7&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=117006d7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117006d7"]])

export default __exports__